import { Booking } from "../components/booking-page/store/slice";
import { Profile } from "../components/login-page/store/slice";
import { StatusCode } from "../components/statuses/store/slice";
import { RoleCode } from "../components/users/store/slice";
import { hasRole } from "./roles";

export const bookingIsCancelable = (
  booking: Booking | null,
  profile: Profile | null
) => bookingIsEditable(booking, profile, true);

export const bookingIsEditable = (
  booking: Booking | null,
  profile: Profile | null,
  isCancelling: boolean = false
) => {
  if (
    !booking ||
    !profile ||
    booking.archived_at ||
    !booking.booking_status ||
    (!isCancelling && !booking.route.can_edit_booking)
  ) {
    return false;
  }

  const isOwner = booking.owner.id === profile.id;

  const isInternal = hasRole(profile, RoleCode.Internal);

  const hasValidStatus = (
    isCancelling
      ? [
          StatusCode.WaitingList,
          StatusCode.Confirmed,
          StatusCode.Failed,
        ]
      : [StatusCode.WaitingList, StatusCode.Confirmed]
  ).includes(booking.booking_status.code);

  const hasValidTicketStatus =
    !booking.ticket_status ||
    ![
      StatusCode.CheckedIn,
      StatusCode.NoShow,
      StatusCode.LateCancellation,
    ].includes(booking.ticket_status.code);

  return hasValidStatus && hasValidTicketStatus
    ? isInternal
      ? true
      : isOwner
    : false;
};
